import React, { Component } from 'react';
import { connect } from 'shalala';
import { Button, Row, Col } from 'react-bootstrap';

import Uuid from '../../support/Uuid';
import { useStore } from '../../store';
import LoadingButton from '../../facturotopia/LoadingButton';
import PageHeader from '../../support/page-header/PageHeader';
import PopConfirm from '../../facturotopia/popconfirm/PopConfirm';
import ResponseError from '../../shared/responses/ResponseError';
import ClientePacsForm from './upsert/components/ClientePacsForm';
import ResponseResult from '../../shared/responses/ResponseResult';
import ClienteConfigForm from './upsert/components/ClienteConfigForm';
import ClienteMinimalForm from './upsert/components/ClienteMinimalForm';
import ClienteServicesForm from './upsert/components/ClienteServicesForm';

class ClientesInvite extends Component {
  steps = [
    {
      number: 1,
      key: 'invite-info',
      done: false,
    },
    {
      number: 2,
      key: 'services',
      isValid: true,
      done: true,
    },
    {
      number: 3,
      key: 'pacs',
      isValid: false,
      done: false,
    },
    {
      number: 4,
      key: 'config',
      isValid: true,
      done: true,
    },
  ];

  constructor(props) {
    super(props);

    props.upsertAction.setPartialState({
      steps: [...this.steps],
    });
  }

  componentWillUnmount() {
    this.props.upsertAction.reset();
  }

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.upsertAction.resetError({
        error: undefined,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    this.props.history.replace('/admin/clientes');
  };

  handleOnSubmit = async () => {
    const { data } = this.props.upsert;
    const body = {
      ...data,
      razon_social: 'Mi empresa',
      rfc: 'XAXX010101000',
      usuario: {
        nombre: data.contacto,
        email: data.email,
        password: data.password || '=ABC=' + Uuid.v4(),
      },
      pacs: data.pacs.map((item) => item.value),
    };

    await this.props.upsertAction.upsert(body);

    const { result } = this.props.upsert;

    if (!!result) {
      window.ToastManager.show({
        variant: 'success',
        title: 'Invitación',
        message: result.message || 'Invitación enviada al cliente',
      });

      this.props.listAction.highlight(result.data);

      this.props.history.replace('/admin/clientes');
    }
  };

  handleOnDataChange = (event) => {
    this.props.upsertAction.setStepDataChange(event);
  };

  renderError = () => {
    const { error } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseResult
          title="Invitación enviada"
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { data = {}, isValid, steps, error, busy } = this.props.upsert;

    if (steps.length === 0) {
      return null;
    }

    return (
      <>
        <PageHeader
          to="/admin/clientes"
          text="Clientes"
        />

        <h5>Nuevo Cliente</h5>

        {!!error && this.renderError()}

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">INFORMACIÓN</strong>
            </div>

            <ClienteMinimalForm
              data={data}
              step={steps[0]}
              history={this.props.history}
              onFormDataChange={this.handleOnDataChange}
            />
          </Col>

          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">CONFIGURACIONES</strong>
            </div>

            <ClienteConfigForm
              data={data}
              step={steps[3]}
              onFormDataChange={this.handleOnDataChange}
            />

            <div className="py-3">
              <strong className="text-info">SERVICIOS</strong>
            </div>

            <ClienteServicesForm
              data={data}
              step={steps[1]}
              onFormDataChange={this.handleOnDataChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">PACS</strong>
            </div>

            <ClientePacsForm
              data={data}
              step={steps[2]}
              onFormDataChange={this.handleOnDataChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <span className="text-muted">
                Se le enviará un email de confirmación al cliente para:
                <ul>
                  <li>Activar su cuenta</li>
                  <li>Completar su información fiscal</li>
                </ul>
              </span>
            </div>
          </Col>
        </Row>

        <Row className="pb-4">
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <PopConfirm
              text="Cancelar el registro de cliente?"
              className="mr-2"
              onAction={this.handleOnAction}
            >
              <Button
                type="button"
                variant="secondary"
                disabled={busy}
                className="mr-2"
              >
                Cancelar
              </Button>
            </PopConfirm>

            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy || false}
              onClick={this.handleOnSubmit}
            >
              {busy === true ? 'Invitando...' : 'Invitar'}
            </LoadingButton>
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (store) => {
  return {
    list: store.admin.clientes.list,
    upsert: store.admin.clientes.upsert,
  };
};

const mapActions = (actions) => {
  return {
    listAction: actions.admin.clientes.list,
    upsertAction: actions.admin.clientes.upsert,
  };
};

export default connect(useStore, mapState, mapActions)(ClientesInvite);
